import GModal from './GModal.vue';

export default GModal;

export { GModal };
